import { render, staticRenderFns } from "./SmartCatalogSearch.vue?vue&type=template&id=46d76cca&scoped=true"
import script from "./SmartCatalogSearch.vue?vue&type=script&lang=js"
export * from "./SmartCatalogSearch.vue?vue&type=script&lang=js"
import style0 from "./SmartCatalogSearch.vue?vue&type=style&index=0&id=46d76cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d76cca",
  null
  
)

export default component.exports